module.exports = __webpack_public_path__ + "assets/img/32-s.6856e19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/32-s.jpg
// module id = e7/v
// module chunks = 0